import React, {useContext} from 'react'
import PropTypes from "prop-types"
import Helmet from 'react-helmet'
import { ThemeContext } from 'styled-components';

import { GlobalStyle } from '../../theme/global'

import bugsnag from '../../services/bugsnag'
const ErrorBoundary = bugsnag.getPlugin('react');

import PageError from '../page-error'

import { Wrapper, Container } from './layout.styles';

import Header from '../header'
import Footer from '../footer'

import '../../theme/fonts.css';

const ErrorScreen = () =>
	<Container>
		<PageError code="500" heading={[{"type":"heading1","text":"Something went wrong","spans":[]}]} text={[{"type":"paragraph","text":"Sorry about this, please try again.","spans":[]}]} />
	</Container>

const Layout = ({children,language,alternateLanguages,meta}) => {
	const themeContext = useContext(ThemeContext);

	return (
		<Wrapper>
			<GlobalStyle {...themeContext} />
			<ErrorBoundary FallbackComponent={ErrorScreen}>
				<Header language={language} alternateLanguages={alternateLanguages} />
				<Container>{children}</Container>
				<Footer language={language} />
			</ErrorBoundary>
		</Wrapper>
	)
}

Layout.propTypes = {
	children: PropTypes.node,
}

export default Layout;